function ToolbarExtensions(/* { appState } */) {
	return null;
}

export default ToolbarExtensions;
